/* eslint-disable no-unused-vars */
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import './EditUser.scss';
import PropTypes from 'prop-types';
import {useFormik} from 'formik';
import actions from '../../../redux/actions';
import * as yup from 'yup';
import _ from 'lodash';
import {useHistory} from 'react-router-dom';
import Loading from '../../../common/components/Loading/Loading';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import ArrowBackComponent from '../../../common/components/ArrowBack/ArrowBack';
import CustomInput from '../../../common/components/CustomInput/CustomInput';
import Button from '../../../common/components/Button/Button';
import {CustomPhone} from '../../../common/components/CustomPhone/CustomPhone';
/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className}>
            {_.get(formik.touched, name) && _.get(formik.errors, name)}
        </div>
    );
};


// Roles de usuario de sede: todos llevan sede y se editan por el endpoint de usuarios
const BRANCH_USER_TYPES = ['PROVIDER_USER', 'PROVIDER_USER_QUOTER', 'PROVIDER_USER_VIEWER'];

const _EditUser = (props) => {
    const {
        name,
        getBranches,
        getBranchesProviders,
        branches,
        branchesProviders,
        providerSelected,
        userSelected,
        editProviderState,
        cleanEditUserState,
        putProvider,
        currentUser,
        getBranchesState,
        getBranchesProvidersState,
        cleanBranches,
        cleanProvidersBranches,
        selectSelf,
        setSelfState,
        cleanSelectSelf,
        showSidebar,
        userInfo,
    } = props;

    const validationSchema = yup.object({
        // password: yup
        //     .string('Ingrese contraseña')
        //     .required('Ingrese contraseña'),
        email: yup
            .string('Ingrese email')
            .email('email inválido')
            .required('Ingrese email'),
        phoneNumbers: yup.array().of(
            yup.object().shape({
                type: yup
                    .string('Ingrese tipo')
                    .required('Ingrese tipo'),
                number: yup.string().when('type', {
                    is: 'OTHER',
                    then: yup.string('Ingrese número')
                        .required('Ingrese número'),
                    otherwise: yup.string('Ingrese número')
                        .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
                            'Número Inválido (No olvide colocar el código de área)')
                        .required('Ingrese número'),
                }),
            }),
        )
            .required('Teléfonos requeridos'),
    });

    useEffect(() => {
        cleanSelectSelf();
        cleanBranches();
        cleanProvidersBranches();
        // solo para admins, si es provider admin solo deberia ver su sede
        if (!currentUser) {
            getBranches();
        } else {
            selectSelf();
        }
        // eslint-disable-next-line
    }, []);

    const history = useHistory();

    useEffect(
        () => {
            if (editProviderState.success) {
                cleanEditUserState();
                history.goBack();
            }
            // eslint-disable-next-line
        }, [editProviderState],
    );


    const formik = useFormik({
        initialValues: {
            id: providerSelected?.providerModel ?
                providerSelected?.providerModel?.id :
                providerSelected?.id ?
                    providerSelected.id :
                '',
            email: providerSelected?.user?.email ? providerSelected.user.email : userSelected.email || '',
            password: providerSelected?.user?.password ? providerSelected.user?.password : '',
            name: providerSelected?.providerModel ?
                providerSelected?.providerModel?.name :
                providerSelected?.name ?
                    providerSelected.name :
                    '',
            cuitOrCuil: providerSelected?.providerModel ?
                providerSelected?.providerModel?.cuitOrCuil :
                providerSelected?.cuitOrCuil ?
                    providerSelected.cuitOrCuil :
                    '',
            phoneNumbers: providerSelected?.providerModel ?
                providerSelected?.providerModel?.phoneNumbers :
                providerSelected?.phoneNumbers ?
                    providerSelected.phoneNumbers :
                    [],
            type: userSelected?.role?.name || '',
            sede: userInfo.salesforceBranchName || '',
            salesforceProviderId: providerSelected?.providerModel ?
                providerSelected?.providerModel?.salesforceProviderId :
                providerSelected?.salesforceProviderId ?
                    providerSelected.salesforceProviderId :
                    '',
            salesforceBranchId: providerSelected?.providerModel ?
                providerSelected?.providerModel?.salesforceBranchId :
                providerSelected?.salesforceBranchId ?
                    providerSelected.salesforceBranchId :
                    '',
            salesForceProviderName: userInfo.salesforceProviderName || '',
            },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const body = {
                id: values.id,
                user: currentUser ?
                    _.omit(values, ['id', 'cuitOrCuil', 'type', 'salesforceProviderId', 'salesforceBranchId', 'password', 'email']) :
                    _.omit(values, ['id', 'name', 'cuitOrCuil', 'type', 'salesforceProviderId', 'salesforceBranchId', 'password']),
                type: BRANCH_USER_TYPES.includes(values.type) ? 'user' : 'admin',
            };
            putProvider(body);
        },
    });

    useEffect(() => {
        if (currentUser && setSelfState.success) {
            getBranches();
        }
        // eslint-disable-next-line
    }, [currentUser, setSelfState.success]);

    useEffect(() => {
        formik.resetForm({values: {...formik.values, salesforceBranchId: ''}});
        if (BRANCH_USER_TYPES.includes(formik.values.type) && formik.values.salesforceProviderId && branches.length > 0) {
            getBranchesProviders(formik.values.salesforceProviderId);
        }
        // eslint-disable-next-line
    }, [formik.values.salesforceProviderId, branches]);

    const [branchesOptions, setBranchesOptions] = useState([]);
    const [branchesProvidersOptions, setBranchesProvidersOptions] = useState([]);

    useEffect(() => {
        if (!providerSelected) return null;
            const keyLen = currentUser ? providerSelected.providerModel.phoneNumbers?.length - 1 : providerSelected.phoneNumbers?.length - 1;
            /*
            setPhoneKeys([...Array(keyLen)].map((x, i) => i));
            setNextPhone(keyLen);
            */
        // eslint-disable-next-line
    }, [providerSelected]);

    useEffect(() => {
        setBranchesOptions(branches?.map((branch) => {
            if (branch.providerId === 'a1l2K000005fIfrQAE') {
                branch.fullName = 'Prestador sin sede';
            }
            return {value: branch.providerId.toString(), label: branch.fullName};
        }));
    }, [branches, getBranchesState.success]);

    useEffect(() => {
        setBranchesProvidersOptions(branchesProviders?.map((branch) => {
            return {value: branch.branchId.toString(), label: branch.fullName};
        }));
        formik.setFieldValue('salesforceBranchId', providerSelected?.salesforceBranchId || '');
        // eslint-disable-next-line
    }, [branchesProviders, getBranchesProvidersState.success]);

    const handleArrowBack = () => {
        history.goBack();
    };

    return (getBranchesState.success ?
        providerSelected?.providerModel || providerSelected?.user ?
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-1' : 'ul-div-background'}
        style={{backgroundColor: 'transparent', margin: '10px', padding: '10px'}}>
            <div className="my-data-inner-container">

                <div className="ul-div-sect-header" style={{justifyContent: 'start'}}>
                        <div style={{width: '40px', height: '40px', marginRight: '40px'}}>
                            <ArrowBackComponent onClick={handleArrowBack}/>
                        </div>
                        <p className="h3 v2-c-text-title">{currentUser ? 'Mis Datos' : 'EDITAR ADMINISTRADOR'}</p>
                </div>

                    <div className="ul-div-form">

                        <form className="eu-form" onSubmit={formik.handleSubmit}>
                            <input type="hidden" name="password" value={formik.values.password}
                                   onChange={formik.handleChange}/>
                            <input type="hidden" name="zipCode" value={formik.values.zipCode}
                                   onChange={formik.handleChange}/>

                            {currentUser ?
                                (
                                    <div className="change-pass-container change-pass">
                                        <div style={{cursor: 'pointer'}}
                                            onClick={() => history.push('/change_password')}>
                                            Cambiar contraseña
                                        </div>
                                    </div>
                                ) : (
                                    <div className="eu-radio-container">
                                        <input
                                            disabled={false}
                                            type={'radio'}
                                            value={'PROVIDER_ADMIN'}
                                            name={'providerAdmin'}
                                            className="eu-radio"
                                            checked={formik.values.type === 'PROVIDER_ADMIN'}
                                        /> Admin de prestador
                                        <input
                                            disabled={true}
                                            type={'radio'}
                                            value={'PROVIDER_USER'}
                                            name={'providerUser'}
                                            className="eu-radio"
                                            checked={formik.values.type === 'PROVIDER_USER'}
                                        /> Usuario de sede
                                    </div>
                                )}

                            <div style={{display: 'flex', gap: '20px', marginBottom: '20px'}}>
                                <CustomInput
                                    label="Nombre"
                                    disabled={false}
                                    placeholder='Nombre'
                                    value={formik.values.name}
                                    onChange={(value) => formik.setFieldValue('name', value)}
                                />
                                <CustomInput
                                    label="CUIT / CUIL"
                                    disabled={true}
                                    placeholder={formik.values.cuitOrCuil}
                                    value={formik.values.cuitOrCuil}
                                    onChange={(value) => formik.setFieldValue('cuitOrCuil', value)}
                                />

                            </div>

                            <div style={{display: 'flex', gap: '20px', marginBottom: '20px', alignItems: 'flex-start'}}>
                                <div style={{flex: 1}}>
                                    <CustomInput
                                        label="Email *"
                                        placeholder={formik.values.email}
                                        disabled={true}
                                        value={formik.values.email}
                                        onChange={(value) => formik.setFieldValue('email', value)}
                                    />
                                </div>
                                <div style={{flex: 1}}></div>
                            </div>

                            <div style={{display: 'flex', gap: '20px', alignItems: 'flex-start'}}>
                                <div style={{flex: 1}}>
                                    <CustomInput
                                        label="Prestador"
                                        disabled={true}
                                        name="salesforceProviderId"
                                        placeholder={formik.values.salesForceProviderName}
                                        value={formik.values.salesForceProviderName}
                                        options={branchesOptions}
                                    />
                                </div>
                                <div style={{flex: 1}}>
                                    {BRANCH_USER_TYPES.includes(formik.values.type) &&
                                        <>
                                            <div style={{
                                                flex: 1,
                                                display: 'flex',
                                                position: 'relative',
                                                alignItems: 'center',
                                                gap: '10px',
                                            }}>
                                                <CustomInput
                                                    label="Sede"
                                                    name="salesforceBranchId"
                                                    className='eu-input-l eu-select'
                                                    onChange={(value) => formik.setFieldValue('salesforceBranchId', value?.value)}
                                                    value={formik.values.sede}
                                                    options={branchesProvidersOptions}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="eu-div-input">
                                                <InputErrorMessage formik={formik} name='salesforceBranchId'
                                                                   className='eu-input-l'/>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>


                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='name' className='eu-input-l'/>
                                <InputErrorMessage formik={formik} name='cuitOrCuil' className='eu-input-s'/>
                            </div>

                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='email' className='eu-input-l'/>
                                <InputErrorMessage formik={formik} name='salesforceProviderId'
                                                   className='eu-input-s'/>
                            </div>
                            <CustomPhone formik={formik}/>
                            <div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
                                <Button type={'submit'} size={'medium'}>Guardar Cambios</Button>
                            </div>

                        </form>
                    </div>
            </div>
        </div> : <Loading className="ul-div-sect-table"/> :
        getBranchesState.loading ? <Loading className="ul-div-sect-table"/> :
            <CustomAlert text={'planes' || String(getBranchesState.error)} severity='error'/>);
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    branches: state.home.branches,
    branchesProviders: state.home.branchesProviders,
    providerSelected: state.home.providerSelected,
    userSelected: state.login.userInfo,
    editProviderState: state.home.editProviderState,
    getBranchesState: state.home.getBranchesState,
    getBranchesProvidersState: state.home.getBranchesProvidersState,
    setSelfState: state.home.setSelfState,
    showSidebar: state.common.showSidebar,
    userInfo: state.login.userInfo,

});

const mapDispatchToProps = (dispatch) => ({
    getBranches: () => dispatch(actions.home.getBranchesRequest()),
    getBranchesProviders: (id) => dispatch(actions.home.getBranchesProvidersRequest(id)),
    putProvider: (providerSelected) => dispatch(actions.home.putProviderRequest(providerSelected)),
    cleanEditUserState: () => dispatch(actions.home.cleanEditUserState()),
    cleanGetBranchesState: () => dispatch(actions.home.cleanGetBranchesState()),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    cleanProvidersBranches: () => dispatch(actions.home.cleanProvidersBranches()),
    selectSelf: () => dispatch(actions.home.selectSelf()),
    cleanSelectSelf: () => dispatch(actions.home.cleanSelectSelf()),
});

_EditUser.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
};


export default connect(mapStateToProps, mapDispatchToProps)(_EditUser);

